exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-box[data-v-91fa71f8] {\n  height: 50px;\n  width: 94%;\n  margin-left: 50px;\n  line-height: 50px;\n  padding-left: 20px;\n  padding-top: 60px;\n  font-size: 20px;\n  color: #6e6e6e;\n  font-weight: 500;\n  border-bottom: 1px solid #f0ecec;\n}\n.form-box[data-v-91fa71f8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 50px;\n  width: 1420px;\n}\n.submit-box[data-v-91fa71f8] {\n  width: 132px;\n  margin-top: 50px;\n}", ""]);

// exports
